export default "__VITE_ASSET__jt2zHOLv__"